module.exports = __webpack_public_path__ + "static/media/Curoflow telemedicine platform in Denmark.5c0eac84.webp";